import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Router, ActivatedRoute, Params } from '@angular/router';
import * as globalConst from './../../../../constants';

// Service
import { LogSapService } from '../../service/logsap/logsap.service';

import * as moment from 'moment';
import { IMyDpOptions } from 'mydatepicker';

@Component({
	selector: 'app-logsap',
	templateUrl: './logsap.component.html',
	providers: [
		LogSapService,
		HttpModule
	]
})
export class LogSapComponent implements OnInit {
	private token;
	public permissoes: any[] = [];
	public resultCount: number = 0;
	public currentPage: number = 0;
	public orderby: string = "DataEnvioSAP";
	public sort: string = "desc";
	public logs: any[] = [];

	constructor(private logService: LogSapService, private router: Router, private route: ActivatedRoute) {
		this.token = localStorage.getItem('yara.token');
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.searchLog();
	}

	setOrder(orderby) {
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc"; 
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;
		this.searchLog();
	}

	searchLog() {
		this.logService.getLogs(this.orderby, this.sort).subscribe(result => {
			this.logs = result.Result; //store all logs
			this.resultCount = result.Count; //count the total result
		});
	}


}



// WEBPACK FOOTER //
// ./src/app/logsap/component/logsap/logsap.component.ts